module.exports = __webpack_public_path__ + "img/1_ru.52b54a65.jpg";